import { Autocomplete, TextField } from "@mui/material";
import { useEffect } from "react";
import { Controller } from "react-hook-form";
import { getStatesList } from "app/api/country_state_api";
function FormStateAutocomplete({
  control,
  name,
  label,
  states,
  selectedCountries,
  selectedStates,
  setSelectedStates,
  setStates,
  statesFromDB,
  setValue,
  disabled,
  rules
}) {
  useEffect(() => {
    let isMounted = true;

    const resetStates = () => {
      setStates([]);
      setValue("jp_state", []);
      setSelectedStates([]);
    };

    const getCountryCodes = (countries) => {
      return countries.map((country) => country.code);
    };

    const getPreloadedStates = (stateData, statesFromDB) => {
      const splitVal = statesFromDB.split("| ").map((val) => val.toLowerCase());
      return stateData.filter((state) => splitVal.includes(state.label.toLowerCase()));
    };

    async function fetchStates() {
      if (!selectedCountries?.length) {
        if (isMounted) resetStates();
        return;
      }

      try {
        const countryCodes = getCountryCodes(selectedCountries);
        const stateData = await getStatesList(countryCodes);

        if (isMounted) {
          setStates(stateData);

          const preloadedStates = statesFromDB ? getPreloadedStates(stateData, statesFromDB) : [];
          setValue("jp_state", preloadedStates);
          setSelectedStates(preloadedStates);
        }
      } catch (error) {
        console.error("Failed to load states:", error);
      }
    }

    fetchStates();

    return () => {
      isMounted = false;
    };
  }, [selectedCountries]);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={selectedStates}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        return (
          <Autocomplete
            {...field}
            fullWidth
            sx={{ width: "100%" }}
            options={states}
            multiple={true}
            value={selectedStates}
            onChange={(_, data) => {
              field.onChange(data);
              setSelectedStates(data);
            }}
            getOptionLabel={(option) => option.label || ""}
            isOptionEqualToValue={(option, value) => option.code === value?.code}
            noOptionsText={"Select a country first"}
            groupBy={(option) => option.countryCode}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label || "Select States"}
                placeholder="Select one or more states"
                fullWidth
                error={!!error}
                helperText={error ? error.message : null}
              />
            )}
            renderOption={(props, option) => (
              <li {...props} key={option.code}>
                {option.label}
              </li>
            )}
            renderGroup={(params) => (
              <li key={params.key}>
                <div
                  style={{
                    position: "sticky",
                    top: -8,
                    padding: "8px 10px",
                    backgroundColor: "#f5f5f5",
                    fontWeight: "bold",
                    zIndex: 1
                  }}
                >
                  {params.group}
                </div>
                <ul style={{ padding: 0 }}>{params.children}</ul>
              </li>
            )}
            ListboxProps={{
              style: {
                maxHeight: "200px",
                scrollbarWidth: "thin"
              }
            }}
            disabled={disabled}
          />
        );
      }}
    />
  );
}

export default FormStateAutocomplete;
